import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import "./Weather.css";

export default function WeatherInfo(props) {
    return (
    <div className="WeatherInfo">
        <div className="WeatherInfo">
            <div className="row">
                <div className="col-12">
    <h1>{props.data.city}</h1>
        <div className="text-weathes-condition">
            <FormattedDate date={props.data.date}/>,<span className="text-weathes-condition">{props.data.description}</span>
        </div>

        <ul>
            <li>
               Humidity: <strong>{props.data.humidity}%</strong>,
               Wind:{" "}<strong>{props.data.wind}km/h</strong>
             </li>
         </ul>
     
    </div>
 <div className="col-lg-6 col-md-6 col-sm-8">
    <div className="temperature-container d-flex justify-content-start ">
                <WeatherIcon code={props.data.icon} size={57} />
                </div>

                <div className="temp">
                <span className="temperature unit">
                <WeatherTemperature celsius={Math.round(props.data.temperature)} />
                </span>

     </div>
    </div>
</div>
</div>
</div>
    );
}